import ApiHttp from "byzantine/src/ApiHttp";
import { useLocalization } from "@fluent/react";
import { Button, TextInput } from "@narmi/design_system";
import { ContextForm, Dialog, useFormData } from "cerulean";

interface EditAccountNameModalProps {
  name: string;
  dialogOpen: boolean;
  setDialogOpen: (newState: boolean) => void;
  accountUuid: string;
}

const EditAccountNameModal = ({
  name,
  dialogOpen,
  setDialogOpen,
  accountUuid,
}: EditAccountNameModalProps) => {
  const { l10n } = useLocalization();
  const { formData, onChange } = useFormData({
    name,
  });

  const onSubmit = (callback: (error?: string) => void) => {
    ApiHttp.fetch(`accounts/${accountUuid}`, { method: "PUT" }, formData)
      .then(() => {
        window.location.assign(
          `/accounts/${accountUuid}/?success=${encodeURIComponent(l10n.getString("edit-account-name-success-message"))}`,
        );
      })
      .catch(() => {
        callback(
          l10n.getString("edit-account-name-error-update"),
        );
      });
  };
  const onCancel = () => {
    setDialogOpen(false);
  };

  const validateName = (value: string | null) => {
    if (value === null)
      return l10n.getString("edit-account-name-error-min-length");
    if (value.length >= 50)
      return l10n.getString("edit-account-name-error-max-length");
    return null;
  };

  return (
    <Dialog
      title={l10n.getString("edit-account-name-modal-title")}
      isOpen={dialogOpen}
      onUserDismiss={() => {
        setDialogOpen(false);
      }}
    >
      <div>{l10n.getString("edit-account-name-modal-description")}</div>
      <ContextForm data={formData} onChange={onChange} nativeForm={false}>
        <div className="margin--top--l">
          <ContextForm.Field required validate={validateName}>
            <TextInput field="name" id="name" label={l10n.getString("edit-account-name-field-label")} />
          </ContextForm.Field>
          <div className="margin--top--xl">
            <div className="edit-modal-action-bar">
              <ContextForm.Action
                noValidation
                onSubmit={onCancel}
                dangerouslyDisableShowLoading
              >
                <Button kind="negative" label={l10n.getString("edit-account-name-button-cancel")} testId="edit-account-cancel"/>
              </ContextForm.Action>
              <div className="margin--left--m">
                <ContextForm.Action onSubmit={onSubmit}>
                  <Button label={l10n.getString("edit-account-name-button-save")} testId="edit-account-save"/>
                </ContextForm.Action>
              </div>
            </div>
          </div>
        </div>
      </ContextForm>
    </Dialog>
  );
};

export default EditAccountNameModal;
